import React from "react";
import PropTypes from "prop-types";
import { useTheme } from "styled-components";

import { RightArrow } from "assets/icons";
import {
  ListItemContainer,
  BoxWrapper,
  BrokerDetails,
  PortfolioWrapper,
  BrokerTitle,
  BrokerType,
  BrokerUrl,
  BrokerImg,
  NameWrapper,
  EligibleMessage,
} from "./ListItem.styles";
import { Tooltip } from "components/Tooltip/index";

export const ListItem = ({
  onClick,
  brokerLogo,
  broker = "Alpaca",
  brokerKey = "",
  eligibleMessage,
  eligible,
  showDivider = false,
  brokerUrl = "",
}) => {
  const theme = useTheme();

  const handleClick = () => {
    if (eligible) {
      onClick();
    }
  };

  return (
    <ListItemContainer eligible={eligible} showDivider={showDivider}>
      <BoxWrapper
        eligible={eligible}
        showDivider={showDivider}
        onClick={handleClick}
        role="button"
        tabIndex={0}
      >
        <BrokerDetails>
          <PortfolioWrapper>
            {brokerLogo && (
              <BrokerImg
                size={35}
                round={true}
                name={broker}
                className="broker-img"
                src={brokerLogo}
              />
            )}
            <div>
              <BrokerTitle>{broker}</BrokerTitle>
              {brokerKey && <BrokerType>{brokerKey}</BrokerType>}
              <BrokerUrl>{brokerUrl ? brokerUrl : null}</BrokerUrl>
              <NameWrapper>
                {eligibleMessage && (
                  <Tooltip
                    value={eligibleMessage}
                    tooltipClassName="v2-tooltip"
                    placement="bottom"
                  >
                    <EligibleMessage>{eligibleMessage}</EligibleMessage>
                  </Tooltip>
                )}
              </NameWrapper>
            </div>
          </PortfolioWrapper>
        </BrokerDetails>
        <RightArrow stroke={theme.card.font.quaternary} />
      </BoxWrapper>
    </ListItemContainer>
  );
};

ListItem.propTypes = {
  onClick: PropTypes.func,
  brokerLogo: PropTypes.string,
  brokerKey: PropTypes.string,
  broker: PropTypes.string,
  eligibleMessage: PropTypes.string,
  eligible: PropTypes.bool,
  showDivider: PropTypes.bool,
  brokerUrl: PropTypes.string,
};

export default ListItem;
